module.exports = __webpack_public_path__ + "static/media/utensilsCleaning.65474733.png";